import React, { useState } from "react";
import { Box, Button, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import EditNoteIcon from '@mui/icons-material/EditNote';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import Timesheets from "../Components/CreateTimesheets";
import LoarAgreementForm from "../LoanAgreement_Components/Forms/LoanAgreement";
import RepaymentStatus from "../LoanAgreement_Components/Forms/ManageRepayment_Status";
import App from "../LoanAgreement_Components/LoanApplicationDocuments_Upload";

const LendMoney: React.FC = () => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const iconStyle = {
    fontSize: '5rem', // Adjust the size as needed
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
      transform: 'scale(1.2)', // Adjust the zoom level as needed
    },
  };


  
  return (
    <div>
      <Button
        sx={{
          bgcolor: 'var(--color-ocean-default)',
          color: 'var(--color-offwhite)',
          py: '20px',
          ':hover': {
            bgcolor: 'var(--color-ocean-highlight)',
            color: 'var(--color-dark-gray)'
          },
          height: '130px',
          maxWidth: '358px',
          mr: 2,
          flexDirection: 'column', // Align content vertically
          gap: 1 // Add some space between icon and text
        }}
        fullWidth
        size="large"
        variant="contained"
        startIcon={<AssignmentIndIcon sx={{mr:'10px'}} style={iconStyle}/>}
        onClick={() => setOpen(true)}
      >
        Loan Applicants
      </Button>
      <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="md"
            fullScreen
            PaperProps={{
                style: {
                backgroundColor: 'rgba(140, 170, 100, 0.95)',
                boxShadow: 'none',
                marginTop: '180px',
                marginRight: '140px',
                marginLeft: '130px',
                height:'750px',
                marginBottom:'100px'
                },

                ml:'100px'
            }}
            >
            <IconButton
                sx={{
                position: "absolute",
                top: "8px",
                right: "8px",
                color: "grey.600",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.1)",
                },
                }}
                onClick={handleClose}
                aria-label="close"
            >
                <CloseIcon
                sx={{
                    border: "2px solid #ff7f7f", // Light red border
                    borderRadius: "4px", // Adjust border radius as needed
                    padding: "4px", // Adjust padding as needed
                }}
                />
            </IconButton>

            <Box sx={{
                marginLeft:'200px',
                mt:'50px',
                mr:'30px'


              }}>
                <Typography
                  className="bold-text"
                  sx={{
                    
                    
                    color: 'var(--color-ocean-highlight)',
                    fontSize: '62px',
                  
                    
                    height: '56px',
                    maxWidth: '100%',
                    mr: 2,
                    ml:'20px',
                  }}
                  align="left"
                  variant="h4"
                  gutterBottom
                >
                  Upload Loan Documents
                </Typography>

            </Box>
            <DialogContent sx={{ marginTop: '10px' }}>

                {/* <Timesheets /> */}
                {/* <LoarAgreementForm/> */}
                {/* <Timesheets/> */}
                {/* <RepaymentStatus/> */}
                {/* <uploadFiles/> */}
                <App/>
            </DialogContent>
        </Dialog>
    </div>
  );
};

export default LendMoney;
